import { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import LayoutFull from "./LayoutFull";
import LayoutAdmin from "./LayoutAdmin";
import AdminHome from "./pages/Admin/AdminHome";
import PrivateRoute from "./Components/PrivateRoute";
// import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
// import Chairmansmessage from "./pages/AboutUs/Chairmansmessage";

import Contactus from "./pages/AboutUs/Contactus";
import Landingpage from "./pages/Landingpage";
import Adminlogin from "./pages/Admin/Adminlogin";
import DirectJalBooking from "./pages/Admin/DirectJalBooking";
import UpdateDelivery from "./pages/Admin/UpdateDelivery";
import UpdateDeliveryBatch from "./pages/Admin/UpdateDeliveryBatch";
import Registeruser from "./pages/Admin/Registeruser";
// import AdminGallery from "./pages/Admin/AdminGallery";
import BookingReportList from "./pages/Admin/BookingReportList";
import DeliveryReportList from "./pages/Admin/DeliveryReportList";
import ForgotPassword from "./pages/Admin/ForgotPassword";
import ResetPassword from "./pages/Admin/ResetPassword";
import ChangePassword from "./pages/Admin/ChangePassword";
import ReportEnquiry from "./pages/Admin/ReportEnquiry";
import Enquiry from "./pages/Enquiry";
import Logout from "./Components/Logout";
import CreateBooking from "./pages/Admin/CreateBooking";
import GenerateBookingReport from "./pages/Admin/GenerateBookingReport";
import GenerateDeliveryReport from "./pages/Admin/GenerateDeliveryReport";
import AllBookingsDeliveries from "./pages/Admin/AllBookingsDeliveries";
import MyBookings from "./pages/Admin/MyBookings";
const App = () => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    } else {
      setToken(null);
      localStorage.removeItem("token");
    }
  }, [token]);

  return (
    <BrowserRouter>
      <Routes>
        {/* routes  without any layout */}
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />

        {/* Full-Width Layout without Sidebars for Home Page */}
        <Route path="/" element={<LayoutFull />}>
          <Route index element={<Landingpage />} />
          <Route
            path="adminlogin"
            element={<Adminlogin setToken={setToken} />}
          />
          <Route path="enquiry" element={<Enquiry />} />
          <Route path="registeruser" element={<Registeruser />} />
          <Route path="createbooking" element={<CreateBooking />} />
          <Route path="mybookings" element={<MyBookings />} />
          <Route path="bookinglists" element={<BookingReportList />} />
          <Route path="deliverylists" element={<DeliveryReportList />} />
          <Route path="allbookingsdeliveries" element={<AllBookingsDeliveries />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="logout" element={<Logout />} />
        </Route>

        {/* Layout with circulars Sidebars for other pages */}
        <Route path="/" element={<Layout />}>
          
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="contactus" element={<Contactus />} />

        </Route>

        {/* Admin Layout for admin pages */}
        <Route path="/" element={<LayoutAdmin />}>
          <Route
            path="adminHome"
            element={
              <PrivateRoute token={token}>
                <AdminHome token={token} />
              </PrivateRoute>
            }
          />
          <Route
            path="directjalbooking"
            element={
              <PrivateRoute token={token}>
                <DirectJalBooking token={token} />
              </PrivateRoute>
            }
          />        
          <Route
            path="updatedelivery"
            element={
              <PrivateRoute token={token}>
                <UpdateDelivery token={token} />
              </PrivateRoute>
            }
          />
          <Route
            path="updatedeliverybatch"
            element={
              <PrivateRoute token={token}>
                <UpdateDeliveryBatch token={token} />
              </PrivateRoute>
            }
          />
          <Route
            path="generateBookingReport"
            element={
              <PrivateRoute token={token}>
                <GenerateBookingReport token={token} />
              </PrivateRoute>
            }
          />
          <Route
            path="generateDeliveryReport"
            element={
              <PrivateRoute token={token}>
                <GenerateDeliveryReport token={token} />
              </PrivateRoute>
            }
          />
           <Route
            path="changepassword"
            element={
              <PrivateRoute token={token}>
                <ChangePassword token={token} />
              </PrivateRoute>
            }
          />
          <Route
            path="reportenquiry"
            element={
              <PrivateRoute token={token}>
                <ReportEnquiry token={token} />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
